import { Customization } from '@eduvision/toolkit';
import image from '../images/BF_Grafik_Module_BFGRATIS_Lehrer.png';

export const DashboardView: Customization['DashboardView'] = {
	heroImageSrc: image,
};
